import type { ContentType } from '@pigello/construct-core';
import type { ModelName } from '@pigello/pigello-matrix';

export function getModelName(contentType: ContentType): ModelName {
  return contentType.split('.').pop() as ModelName;
}

export function isVisibleField(
  meta: { isReadonly?: boolean },
  fieldPerms: { canView?: boolean } | undefined
) {
  if (meta.isReadonly) {
    return false;
  }
  if (fieldPerms && fieldPerms.canView === false) {
    return false;
  }
  return true;
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isMessageScalar(value: unknown) {
  return (
    value === null ||
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    value instanceof Date
  );
}

export function stringifyMessage(value: unknown) {
  if (typeof value === 'string') {
    return value;
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (
    value === null ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return String(value);
  }
  if (isRecord(value) && typeof value.message === 'string') {
    return value.message;
  }
  return undefined;
}

export function toFieldError(error: unknown): { message: string } | undefined {
  const message = stringifyMessage(error);
  return message ? { message } : undefined;
}
